export default function Menu() {
	let btn = document.createElement( 'button', {id: "m_btn"} ),
		menu = document.getElementById( 'h_menu' );

	// Adding classes and setting button text
	addClass( btn, 'h-menu__btn' );
	btn.textContent = 'Меню';

	// Inserting button and adding click event listener
	if ( menu ) {
		menu.insertBefore( btn, menu.firstChild );
		btn.addEventListener( 'click', function () {
			toggleClass( menu, 'active' );
		} );
	}

	function addClass( el, className ) {
		if ( el.classList ) {
			el.classList.add( className );
		} else {
			el.className += ' ' + className;
		}
	}

	function removeClass( el, className ) {
		if ( el.classList ) {
			el.classList.remove( className );
		} else {
			el.className = el.className.replace(
				new RegExp( '(^|\\b)' + className.split( ' ' ).join( '|' ) + '(\\b|$)', 'gi' ), ' ' );
		}
	}

	function toggleClass( el, className ) {
		if ( el.classList ) {
			el.classList.toggle( className );
		} else {
			let classes = el.className.split( ' ' );
			let existingIndex = classes.indexOf( className );

			if ( existingIndex >= 0 ) {
				classes.splice( existingIndex, 1 );
			} else {
				classes.push( className );
			}

			el.className = classes.join( ' ' );
		}
	}
}